import React, {FC, useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import { useInjectSagaAndReducer } from '../../../utils/helpers';
import { REDUX_SAGA_KEYS } from '../../../config/config';
import saga from '../saga';
import reducer from '../reducer';

// Import Styles
import styled from 'styled-components';
import H1 from '../../../components/Headings/H1';
import P from '../../../components/Paragraph';
import Button from '../../../components/Buttons';
import FormInput from '../../../components/Inputs/Input/index';
import {enterPassword} from './../actions';
import CustomHelmet from '../../../components/Helmet';
import FormGroup from '../../../components/Inputs/FormGroup';

// Import Messages and Formats
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import generalMessages from '../../generalMessages';
import intl from "../../../intl";
import IntlTelInput from 'react-intl-tel-input';
import InputTel from '../../../components/Inputs/InputTel';
import 'react-intl-tel-input/dist/main.css';
import Label from '../../../components/Inputs/Label';

// Import Validation
import Validator from 'validatorjs';
import ResetPasswordValidationRules from './ResetPasswordValidationRules';
import ResetPasswordValidationMessages from './ResetPasswordValidationMessages';
import ErrorMessage from '../../../components/Inputs/ErrorMessage';
import history from '../../../utils/history'

const ResetPasswordPhoneNumber: FC = () => {

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');

  useInjectSagaAndReducer(REDUX_SAGA_KEYS.forgotPassword, reducer, saga);

  const dispatch = useDispatch();

  const [phone, setPhone] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');

  const [phoneError, setPhoneError] = useState<boolean | string>('');
  const [passwordlError, setPasswordError] = useState<boolean | string>('');
  const [confirmPasswordError, setConfirmPasswordError] = useState<boolean | string>('');

  useEffect(()=>{
    if(!code) {
      history.push('/');
    }
  }, [code]);

  const setNumberWrapper = useCallback((isValid, number, selectedCountryData, fullNumber) => {
    if(isValid) {
      setPhone(fullNumber)
    }
  },[]);

  const submitForm = useCallback((e) => {
    e.preventDefault();

    let data = {
      phone: phone,
      password: password,
      password_confirmation: confirmPassword,
      code: code
    };

    let validation = new Validator(data, ResetPasswordValidationRules, ResetPasswordValidationMessages);

    validation.fails(() => {
      setPhoneError(validation.errors.first('phone'));
      setPasswordError(validation.errors.first('password'));
      setConfirmPasswordError(validation.errors.first('confirmPassword'));
    });
    validation.passes(() => {
      setPhoneError('');
      setPasswordError('');
      setConfirmPasswordError('');
      dispatch(enterPassword(data));
    });

  }, [phone, password, confirmPassword, code, dispatch]);

  return (
    <ForgotPassword>
      <CustomHelmet
        title="Unesi novu lozinku"
        link="/forgotten-password/"
      />
        <H1><FormattedMessage {...messages.Header} /></H1>
        <Form onSubmit={submitForm}>
          <P><FormattedMessage {...messages.TextPhone} /></P>
          <FormGroup>
            <Label><FormattedMessage {...generalMessages.Phone} /> <sup>*</sup></Label>
            <InputTel>
               <IntlTelInput
                preferredCountries={['rs', 'hr', 'ba', 'me']}
                onPhoneNumberChange={setNumberWrapper}
                separateDialCode={true}
                containerClassName="intl-tel-input"
                inputClassName="form-control"
              />
            </InputTel>
            {phoneError ? <ErrorMessage>{phoneError}</ErrorMessage>: null}
          </FormGroup>
          <FormGroup>
            <FormInput
               inputPlaceholder={intl.formatMessage(generalMessages.InputPassword)}
               defaultValue={password}
               onInputChange={setPassword}
               type={'password'}
            />
            {passwordlError ? <ErrorMessage>{passwordlError}</ErrorMessage> : null}
          </FormGroup>
          <FormGroup>
            <FormInput
               inputPlaceholder={intl.formatMessage(generalMessages.InputRetypePassword)}
               defaultValue={confirmPassword}
               onInputChange={setConfirmPassword}
               type={'password'}
            />
            {confirmPasswordError ? <ErrorMessage>{confirmPasswordError}</ErrorMessage> : null}
          </FormGroup>
          <FormGroup>
            <ButtonSend type="submit"><FormattedMessage {...messages.Button} /></ButtonSend>
          </FormGroup>
        </Form>
    </ForgotPassword>
  )
}

const ForgotPassword = styled.div`
  margin: auto 0;
`;

const Form = styled.form`
  margin-top: 70px;
`;

const ButtonSend = styled(Button)`
  width: 100%;
`;

export default ResetPasswordPhoneNumber;
